<section>
  <div class="subSection">
    <div class="left">
      @if (discount.featured) {
        <p class="discount"><b>Featured Discount</b></p>
      }
      <h4>{{discount.partnerName}} </h4>
      <p [innerHTML]="discount.offerDescription"></p>
      <div>
        <p class="discount">DISCOUNT</p>
        <div class="price"[innerHTML]="discount.offer"></div>
      </div>
    </div>
    <div class="right">
      <img src="{{discount.partnerLogoUrl}}" alt="{{discount.partnerName}}">
      @if (discount.redemptionMethod === 'url') {
        <button type="button" (click)="openUrl(discount)" class="regular button solid-green">{{discount.redemptionCTA}}</button>
      }
      @if (discount.redemptionMethod === 'code') {
        <button type="button" (click)="emitDiscount(discount)"  class="regular button solid-green">{{discount.redemptionCTA}}</button>
      }
    </div>
  </div>
</section>
